<script setup lang="ts">

import {ref} from "vue";

const faqs = <any>ref([
    {
        q: "I want it faster, are you able to rush my order?",
        a: "Yes. Please email us at orders@teambannersports.com with your request for expedited processing."
    },
    {
        q: "What is a Pole Pocket banner?",
        a: "A Pole Pocket banner is a 5' x 3' banner, digitally printed on 13-oz vinyl, with the top and bottom edges hemmed 4 inches inward to allow insertion of poles for hanging. This design is ideal for parades, and we strongly recommend using a stand for added stability."
    },
    {
        q: "Is the logo design, photo, or image I am uploading acceptable for printing?",
        a: "To ensure the best print quality, we recommend using images with a minimum resolution of 300 DPI. Use our zoom tool to check your image – if it appears pixelated upon zooming in, it may not be suitable for printing."
    },
    {
        q: "Can the banners be hemmed?",
        a: "Yes, hemmed banners provide additional strength and durability at no extra cost. Hems are especially effective when combined with reinforced grommets."
    },
    {
        q: "What types of payment do you accept?",
        a: "We accept Visa, MasterCard and Amex."
    },
    {
        q: "Can I order a pennant in a triangle or home plate shape?",
        a: "Please note that for pennant types such as TRIANGLE PENNANT or HOME PLATE PENNANT, we do not provide cutting services to shape them into a triangle or home plate. We only offer large-format printing in square or rectangular shapes. Therefore, if you order a pennant, we will offer an extremely low price of just $3.99 per pennant. We will print a large sheet that includes all the pennant shapes within and deliver it to you. Upon receiving it, you will need to cut out the pennants yourself. We apologize for this inconvenience and appreciate your understanding."
    },
    {
        q: "Can I pick up the order?",
        a: "You can pick up your order at the following address: 462 Humane Way, Pomona, CA 91766"
    }
]);


</script>

<template>
<div c2c-0 class="cc">
    <div c2c-1 class="w-100%-max:1200 p-30-12">
        <h1>Frequently Asked Questions (FAQs) – Team Banner Sports</h1>
        <ul c2c-2 class="m-t-30
                    >>.an none
                    >>li.active>>.an block
                    >>li>>.up none
                    >>li.active>>.up block
                    >>li>>.down block
                    >>li.active>>.down none
">
            <li v-for="faq in faqs" :class="{active: faq.ex ? faq.ex : false}">
                <p c2c-3 class="qu bd m-t--1 p-12 bg-0-l:-10 cur-1 rw usn" @click="faq.ex = !(!!faq.ex)">
                    {{faq.q}}
                    <span c2c-4 class="down icon-down-open-mini"></span>
                    <span c2c-5 class="up icon-up-open-mini"></span>
                </p>
                <p c2c-6 class="an p-12">{{faq.a}}</p>
            </li>
        </ul>

        <p c2c-7 class="m-t-32"><em>If your question was not answered here, feel free to reach out to us—we're here to help!</em></p>
    </div>
</div>
</template>

<style scoped>

</style><style lang="scss" scoped>.cc[c2c-0] {
                        display: flex; flex-direction: column; align-items: center;
                 }.w-100\%-max\:1200[c2c-1] {
                        width: 100%;max-width: 1200px;
                 }.p-30-12[c2c-1] {
                        padding-top: 30px;padding-right: 12px;padding-bottom: 30px;padding-left: 12px;
                 }.m-t-30[c2c-2] {
                        margin-top: 30px;
                 }.\>\>\.an.none[c2c-2] .an {
                        display: none;
                 }.\>\>li\.active\>\>\.an.block[c2c-2] li.active .an {
                        display: block;
                 }.\>\>li\>\>\.up.none[c2c-2] li .up {
                        display: none;
                 }.\>\>li\.active\>\>\.up.block[c2c-2] li.active .up {
                        display: block;
                 }.\>\>li\>\>\.down.block[c2c-2] li .down {
                        display: block;
                 }.\>\>li\.active\>\>\.down.none[c2c-2] li.active .down {
                        display: none;
                 }.bd[c2c-3] {
                        border-width: 1px; border-style: solid; border-color: hsla(0, 0%, 72.5%, 0.7)
                 }.m-t--1[c2c-3] {
                        margin-top: -1px;
                 }.p-12[c2c-3] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.bg-0-l\:-10[c2c-3] {
                        background-color: hsl(0, 0%, 90%);
                 }.cur-1[c2c-3] {
                        cursor: pointer;
                 }.rw[c2c-3] {
                        display: flex; flex-direction: row; justify-content: space-between;
                 }.usn[c2c-3] {
                        user-select: none;
                 }.p-12[c2c-6] {
                        padding-top: 12px;padding-right: 12px;padding-bottom: 12px;padding-left: 12px;
                 }.m-t-32[c2c-7] {
                        margin-top: 32px;
                 }</style>